import { Link } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthProvider';
import { MenuIcon } from './icons';

function iniciales(usuario: string): string {
  return usuario.slice(0, 2).toUpperCase();
}

interface Props {
  titulo: string;
  onAbrirMenu: () => void;
}

export function AdminTopbar({ titulo, onAbrirMenu }: Props) {
  const { sesion, logout } = useAuthContext();

  return (
    <header className="flex items-center justify-between gap-3 px-4 md:px-10 py-4 bg-white border-b border-admin-border">
      <div className="flex items-center gap-3 min-w-0">
        <button
          type="button"
          onClick={onAbrirMenu}
          className="text-admin-ink md:hidden shrink-0"
          aria-label="Abrir menú"
        >
          <MenuIcon />
        </button>
        <div className="text-base font-bold text-wood truncate">{titulo}</div>
      </div>
      <div className="flex items-center flex-wrap justify-end gap-x-3 gap-y-1">
        <div className="w-8 h-8 rounded-full bg-terracotta text-white flex items-center justify-center text-[13px] font-bold shrink-0">
          {sesion ? iniciales(sesion.usuario) : '—'}
        </div>
        <div className="text-[13px] hidden sm:block">
          <span className="font-semibold">{sesion?.usuario}</span>{' '}
          <span className="text-admin-ink-muted">· {sesion?.rol}</span>
        </div>
        <Link
          to="/admin/cambiar-password"
          className="text-xs font-semibold text-admin-ink-muted hover:text-terracotta"
        >
          Cambiar contraseña
        </Link>
        <button
          onClick={logout}
          data-testid="admin-logout-button"
          className="text-xs font-semibold text-admin-ink-muted hover:text-terracotta"
        >
          Cerrar sesión
        </button>
      </div>
    </header>
  );
}
